// Definição para o modal de busca de Tabelas de Preços Comercial
// Factory function - recebe filtros como parâmetros, sem magic strings

import { ST } from '@/constants/ST'

export const criarConfigBuscaPrecoComercial = () => ({
  label: 'Tabela de Preços',
  placeholder: 'Nome da Tabela...',
  titulo: 'Selecionar Tabela de Preços',
  endpointApi: 'PrecosComerciais',
  idField: 'idPrecoComercial',
  displayField: 'idPrecoComercial',
  descField: 'nome',
  // Necessário para o ModalDeBusca resolver os códigos Lst* (lstMoeda, lstStatus)
  // em textos amigáveis via Dicionário de Metadados (resolverListasEmLote).
  tabela: 'PrecoComercial',
  camposFiltro: [
    { label: 'Nome da Tabela', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idPrecoComercial', width: '10%' },
    { header: 'Nome da Tabela', dataField: 'nome', width: '55%' },
    { header: 'Moeda', dataField: 'lstMoeda', width: '15%' },
    { header: 'Status', dataField: 'lstStatus', width: '20%' }
  ],
  // Filtro fixo: apenas tabelas de preço Ativas (ST1)
  filtrosFixos: {
    lstStatus: ST.Ativo
  }
})
